import React from 'react'
import { Link } from 'react-router-dom'
import { IconCategory } from '../../../../../../shared/icon/icon'
import { SearchHighlight } from './search-highlight'

const SEPARATOR = ' › '

// The breadcrumb the matcher scored is the ancestors' names joined by " › "
// (shared/search, as the viewer's). Its matched indices, split onto the
// folder each falls in, relative to that folder's name.
export const pathSegments = (labels, ids, indices) => {
  const names = Array.isArray(labels) ? labels : []
  const hits = new Set(indices || [])
  const segments = []
  let start = 0
  names.forEach((name, i) => {
    const own = []
    for (let k = 0; k < name.length; k++) if (hits.has(start + k)) own.push(k)
    segments.push({ id: ids ? ids[i] : undefined, name, hits: own })
    start += name.length + SEPARATOR.length
  })
  return segments
}

// Past this many characters, a path of three or more folders keeps its first
// and last folder and folds the ones between into "…" (the full path is the
// line's hover). Shorter paths only shrink their middle folders' names, with
// an ellipsis, when the row is narrow.
const FOLD_PAST = 48

// Where a result lives (owner 2026-10-09: "difficult to know where the
// results live"): a folder icon, the area's root, then each folder above the
// result, each a link to that folder, the matched letters marked as in the
// name. A result at the top of the area shows the root alone.
export const SearchPath = ({ area, nodes, entry, indices }) => {
  const segments = pathSegments(entry.pathLabels, entry.pathIds, indices)
  const full = [area.rootLabel, ...segments.map(s => s.name)].join(SEPARATOR)
  const long = segments.length >= 3 && full.length > FOLD_PAST
  const shown = long ? [segments[0], { fold: segments.slice(1, -1) }, segments[segments.length - 1]] : segments

  return (
    <nav className="node-search-path" aria-label={`Location: ${full}`} title={full}>
      <span className="node-search-path-icon" aria-hidden="true">
        <IconCategory />
      </span>
      <Link className="node-search-path-root" to={area.rootHref}>
        {area.rootLabel}
      </Link>
      {shown.map((segment, i) =>
        <React.Fragment key={segment.fold ? 'fold' : `${segment.id}-${i}`}>
          <span className="node-search-path-sep" aria-hidden="true">
            ›
          </span>
          {segment.fold
            ? <span className={segment.fold.some(s => s.hits.length) ? 'node-search-path-fold search-hit-fold' : 'node-search-path-fold'} aria-hidden="true">
                …
              </span>
            : <Link className={i === shown.length - 1 ? 'node-search-path-folder node-search-path-last' : 'node-search-path-folder'} to={area.folderHref(nodes, segment.id)}>
                <SearchHighlight text={segment.name} indices={segment.hits} />
              </Link>}
        </React.Fragment>
      )}
    </nav>
  )
}
